import { Grid } from "@mui/material";
import { ContactForm } from "./ContactForm";
import { ContactInfo } from "./ContactInfo";

export const ContactContainer = () => (
	<Grid
		container
		columnSpacing={5}
		direction="row"
		justifyContent="space-around"
		sx={{ px: "10%", py: "2%" }}
	>
		<ContactForm />
		<ContactInfo />
	</Grid>
);
